"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageUserEdit = void 0;
const react_1 = __importStar(require("react"));
const authContext_1 = require("../../context/authContext");
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const useBackToLastLocation_1 = require("../../utils/useBackToLastLocation");
const Spinner_1 = require("../spinner/Spinner");
const UserEditor_1 = require("../user-editor/UserEditor");
const ManagerPageUserEdit = (props) => {
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const config = (0, configContext_1.useConfig)();
    const lastLocation = (0, useBackToLastLocation_1.useBackToLastLocation)(`/manager/${config.tenantId}/`);
    const [errorEmailExists, setErrorEmailExists] = (0, react_1.useState)("");
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    async function handleSave(user) {
        setIsSaving(true);
        // Save the user via Firebase functions.
        const response = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/users/${user.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: await authInfo.getAuthHeader(),
            },
            body: JSON.stringify(user),
        });
        if (response.status === 409) {
            // Another user with the same email address already exists.
            setErrorEmailExists(user.email);
        }
        else {
            setErrorEmailExists("");
        }
        // Reload the new user auth infos.
        await authInfo.reload();
        setIsSaving(false);
    }
    function handleClose() {
        lastLocation.goBack();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, isSaving ? (react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" })) : (react_1.default.createElement(UserEditor_1.UserEditor, { user: authInfo.user, errorEmailExists: errorEmailExists, onClose: handleClose, onSave: handleSave }))));
};
exports.ManagerPageUserEdit = ManagerPageUserEdit;
